export const PageHeader = ({ eyebrow, title, desc, action }) => (
  <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between animate-rise">
    <div>
      <div className="mb-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#FF6B00]">{eyebrow}</div>
      <h1 className="font-heading text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="page-title">{title}</h1>
      {desc && <p className="mt-3 max-w-2xl text-sm text-slate-400 sm:text-base">{desc}</p>}
    </div>
    {action}
  </div>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <div className={`rounded-xl border border-[#282E3D] bg-[#141721] ${className}`} {...rest}>{children}</div>
);

export const Empty = ({ icon: Icon, title, desc, testId }) => (
  <Panel className="flex flex-col items-center justify-center px-6 py-16 text-center" data-testid={testId}>
    {Icon && <Icon className="mb-4 h-8 w-8 text-slate-600" />}
    <div className="font-heading text-lg font-semibold">{title}</div>
    {desc && <p className="mt-1 max-w-sm text-sm text-slate-500">{desc}</p>}
  </Panel>
);

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-lg bg-[#FF6B00] px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#FF6B00]/20 transition-[background-color,transform] duration-200 hover:bg-[#D95200] active:scale-[0.98] disabled:opacity-50";
export const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-[#282E3D] bg-transparent px-4 py-2.5 text-sm font-medium text-slate-200 transition-colors duration-200 hover:border-[#FF6B00]/60 hover:text-white disabled:opacity-50";
export const inputCls =
  "w-full rounded-lg border border-[#282E3D] bg-[#0B0D12] px-3.5 py-2.5 text-sm text-slate-100 placeholder:text-slate-600 outline-none transition-colors focus:border-[#FF6B00]";
